import { render } from "./GameLinkView.vue?vue&type=template&id=23c85c75&scoped=true"
import script from "./GameLinkView.vue?vue&type=script&lang=js"
export * from "./GameLinkView.vue?vue&type=script&lang=js"

import "./GameLinkView.vue?vue&type=style&index=0&id=23c85c75&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c85c75"]])

export default __exports__